import {motion} from 'motion/react';
import {DEFAULT_CUBIC, DEFAULT_DURATION} from '@/styles/animation';

interface HamburgerButtonProps {
  isOpen: boolean;
  onClick: () => void;
  className?: string;
}

const LINE_TRANSITION = {
  duration: DEFAULT_DURATION,
  ease: DEFAULT_CUBIC,
};

/**
 * Animated hamburger menu button that morphs between three horizontal
 * lines and an X shape when `isOpen` changes.
 */
export function HamburgerButton({
  isOpen,
  onClick,
  className,
}: HamburgerButtonProps) {
  return (
    <button
      onClick={onClick}
      className={className}
      aria-label="Toggle menu"
    >
      <svg width="24" height="24" viewBox="0 0 24 24">
        {/* Top line → slides to center then rotates 45° */}
        <motion.line
          x1="4"
          x2="20"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          initial={false}
          animate={{
            y1: isOpen ? 12 : 6,
            y2: isOpen ? 12 : 6,
            rotate: isOpen ? 45 : 0,
          }}
          transition={LINE_TRANSITION}
          style={{transformOrigin: '12px 12px'}}
        />
        {/* Middle line → fades out */}
        <motion.line
          x1="4"
          y1="12"
          x2="20"
          y2="12"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          initial={false}
          animate={{opacity: isOpen ? 0 : 1}}
          transition={LINE_TRANSITION}
        />
        {/* Bottom line → slides to center then rotates -45° */}
        <motion.line
          x1="4"
          x2="20"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          initial={false}
          animate={{
            y1: isOpen ? 12 : 18,
            y2: isOpen ? 12 : 18,
            rotate: isOpen ? -45 : 0,
          }}
          transition={LINE_TRANSITION}
          style={{transformOrigin: '12px 12px'}}
        />
      </svg>
    </button>
  );
}
